(()=>{
  if(window.ehqMediaPerformance)return;
  window.ehqMediaPerformance=true;
  const states=new WeakMap();
  function hydrate(video){
    if(video.dataset.ehqLoaded)return;
    video.dataset.ehqLoaded='true';
    if(video.dataset.ehqPoster)video.poster=video.dataset.ehqPoster;
    for(const node of [video,...video.querySelectorAll('[data-ehq-src]')]){
      if(node.dataset.ehqSrc)node.setAttribute('src',node.dataset.ehqSrc);
    }
    video.load();
  }
  function sync(video){
    const visible=states.get(video)&&!document.hidden;
    if(!visible){video.pause();return;}
    hydrate(video);
    if(video.autoplay){video.muted=true;video.play().catch(()=>{});}
  }
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){states.set(entry.target,entry.isIntersecting&&entry.intersectionRatio>=.15);sync(entry.target);}
  },{threshold:[0,.15]});
  function scan(root){
    for(const video of root.querySelectorAll('video[data-ehq-lazy-video]')){
      if(states.has(video))continue;
      states.set(video,false);observer.observe(video);
      video.addEventListener('pointerdown',()=>hydrate(video),{once:true});
      video.addEventListener('focus',()=>hydrate(video),{once:true});
    }
  }
  scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('visibilitychange',()=>{
    for(const video of document.querySelectorAll('video[data-ehq-lazy-video]'))sync(video);
  });
})();
